import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-final-form';
import { required } from 'form/validation';
import strings from 'localization/strings';
import { convertToNumber } from 'helpers/StringHelper';
import { getBusinessOrPrivateName } from 'helpers/ActorHelper';

import Box from '@material-ui/core/Box';
import { Radios, Checkboxes, TextField, showErrorOnBlur } from 'mui-rff';
import PredefinedTextSelector, { insertPredefinedText } from 'common/PredefinedTextSelector';

const SendMessageFormFields = ({ tenantActor, ownerActor, predefinedTexts }) => {
    const bodyContainerRef = useRef(null);
    const form = useForm();
    const formValues = form.getState().values;

    // must use strings as values
    const senderItems = [
        { label: strings.formatString('Send message as tenant ({0})', getBusinessOrPrivateName(tenantActor)), value: '' + tenantActor.id },
        { label: strings.formatString('Send message as owner ({0})', getBusinessOrPrivateName(ownerActor)), value: '' + ownerActor.id }
    ];

    const getRecipientNamesString = () => {
        const recipientActors = [];
        if(formValues.sendAsAdmin) {
            recipientActors.push(tenantActor);
            recipientActors.push(ownerActor);
        } else {
            recipientActors.push(convertToNumber(formValues.senderActorId) === ownerActor.id
                ? tenantActor
                : ownerActor
            );
        }
        return recipientActors.map(o => o.name).join(' and ');
    };

    const handlePredefinedTextSelect = predefinedText => {
        insertPredefinedText({
            containerRef: bodyContainerRef,
            fieldName: 'body',
            form,
            predefinedText
        });
    };

    return (
        <>
            <Radios
                name="senderActorId"
                data={senderItems}
            />

            <Checkboxes
                name="sendAsAdmin"
                data={
                    { label: 'Send message as admin', value: true }
                }
                helperText="Check the box to send the message with yourself as the sender to both the tenant and the owner."
            />

            <Box ref={bodyContainerRef}>
                <TextField
                    name="body"
                    label={strings.formatString('New message to {0}', getRecipientNamesString())}
                    variant="outlined"
                    showError={showErrorOnBlur}
                    required
                    fieldProps={{ validate: required }}
                    multiline
                    rows={4}
                />
            </Box>

            <PredefinedTextSelector
                predefinedTexts={predefinedTexts}
                label="Insert predefined text"
                onSelect={predefinedText => handlePredefinedTextSelect(predefinedText)}
            />
        </>
    );
};

SendMessageFormFields.propTypes = {
    tenantActor: PropTypes.object.isRequired,
    ownerActor: PropTypes.object.isRequired,
    predefinedTexts: PropTypes.array.isRequired
};

export default SendMessageFormFields;
